<template>
  <div class="aboutBox">
    <div class="title">
        <img class="image" src="./img/title.png" alt="">
    </div>
    <p class="BigTitle">企业介绍</p>
    <p class="smallTitle">郑州时空 — 企业数智化整体解决方案服务商</p>
    <div class="titleText" >
        <p>郑州时空成立于2002年，公司20多年来一直专注于以数字化、智能化推动企业进步，是国内领先的企业数智化整体解决方案服务商。</p>
        <p>郑州时空是中国最大的企业管理软件服务商联盟之一“数字时空医药”联盟的发起成员，是全国最大的企业互联网化服务联盟“幸福时空”的联合创始人及核心成员，创建了“5+15+30”的服务生态圈，始终坚定“客户成功、员工成长、企业成就”经营目标，秉持“高效专业、提升价值”的服务理念，“时空”品牌持续20年成为中国企业数智化服务的标杆。</p>
       <p>郑州时空将致力于以数智化推动企业进步，将数字化、智能化技术服务做为公司核心竞争力，在管理软件的开发实施服务、智能仓储物流设备集成、工业智能化设备等方面持续投入，为客户提供更全面的数智化解决方案，不断超越自我，追求卓越，成为国内一流的企业数智化整体解决方案服务商。</p>
    </div>
    <!-- 宣传 -->
    <div class="video">
      <iframe src="//player.bilibili.com/player.html?bvid=BV1XP411m7v3&page=1&high_quality=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" > </iframe>
      <!-- <iframe  src='https://player.youku.com/embed/XNTk2MzgwMDkzMg==' frameborder=0 ></iframe> -->
    </div>
    <!-- 图片区域 -->
    <div class="imgBox">
    <p class="newTitleOne">
      <img class="image" src="./img/newTitle2.png" alt=""> 
    </p>
    <p class="newTImgOne">
      <img class="image" src="./img/newImg1.png" alt="">
    </p>
    <!-- 分割线 -->
    <p class="wire"></p>
    <p class="newTitleTwo">
      <img class="image" src="./img/newTitle1.png" alt="">
    </p>
    </div>
    <p class="newTImgTwo">
      <img class="image" src="./img/newImg2.png" alt="">
    </p>
    <p class="newPic">
      <img class="image" src="./img/newPic.png" alt="">
    </p>
    <p class="newCall">
      <img class="image" src="./img/callMe.png" alt="">
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
$md:75/192*2;
 .image{
    width: 100%;
    height: 100%;
 }
 p{
  margin: 0;
 }
 .title{
    width: 100%;
 }
 .BigTitle{
  font-size: 32px/$md;
  font-weight: 400;
  color: #000000;
  text-align: center;
  margin: 40px/$md 0 30px/$md 0;
 }
 .smallTitle{
  width: 687px/$md;
  margin: auto;
  font-size: 26px/$md;
  font-weight: 400;
  color: #000000;
 }
  .titleText{
    width: 687px/$md;
    font-size: 24px/$md;
    font-weight: 400;
    color: #5F5E5E;
    margin: auto;
    margin-top: 20px/$md;
    margin-bottom: 10px/$md;
    overflow: hidden;
   p{
    // padding:15px/$md 30px/$md;
      line-height: 40px/$md;
      letter-spacing: 1px/$md;
      margin-bottom: 30px/$md;
   }
 }
 .video{
  width: 687px/$md;
  height: 385px/$md;
  margin: auto;
  margin-bottom: 50px/$md;
  iframe{
    width: 100%;
    height: 100%;
  }
 }
//  图片区域
.imgBox{
  width: 690px/$md;
  margin: auto;
}
.newTitleOne{
  width: 165px/$md;
  height: 71px/$md;
  margin-bottom: 30px/$md;
}
.newTImgOne{
  width: 690px/$md;
  height: 524px/$md;
}
.wire{
  height: 30px/$md;
  border-bottom: 3px/$md solid #F0F0F0;
  margin-bottom: 30px/$md;
}
.newTitleTwo{
  width: 288px/$md;
  height: 71px/$md;
  margin-bottom: 30px/$md;
}
.newTImgTwo{
  width: 750px/$md;
  height: 760px/$md;
    margin: auto;
}
.newPic{
  width: 100%;
  height: 442px/$md;
}
.newCall{
  width: 100%;
  height: 442px/$md;
}
</style>
